<!-- UseInterval内のため使用不可ダイアログ -->
<template>
  <ItemDialog ref="DialogInvalidUseInterval" imageType="alert">
    <template v-slot:content-area>
      <p style="text-align: center">利用可能時間外です。</p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="戻る"
        actionType="btn-primary"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "DialogInvalidUseInterval",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogInvalidUseInterval = ref(null);
    const book = store.getters["ticketing/book"];
    const sheet = store.getters["ticketing/sheet"];

    const openDialog = () => {
      DialogInvalidUseInterval.value.open();
    };

    const closeDialog = () => {
      DialogInvalidUseInterval.value.close();
      goToSheet();
    };

    const goToSheet = () => {
      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: book.id,
          master_sheet_id: sheet.master_sheet_id,
          sheet_id: String(sheet.id),
        },
        query: { language: store.getters["common/lang"] },
      });
    };

    return {
      DialogInvalidUseInterval,
      openDialog,
      closeDialog,
    };
  },
};
</script>
